// Vendor imports
const { connect } = require('react-redux')
// Entry imports
const smsModalActions = require('client-v2/into-landing/containers/sms-modal/actions')
// Container imports
const TopicProfileLayout = require('./component-dumb')
const selectors = require('./into-item-card-selectors')

function mapStateToProps(state) {
  return {
    // Flags
    isAndroid: state.env.browser.has('android'),
    isIos: state.env.browser.has('ios'),
    isDesktop: state.env.browser.has('isDesktop'),
    // Values
    baseUrl: state.env.baseUrl,
    iosDeeplinkHref: state.env.deeplinkUrls.get('ios'),
    emptyFeedItems: selectors.getEmptyItemCards(state),
    feedItems: selectors.getItemCards(state),
    topic: state.topicProfile
  }
}

const mapDispatchToProps = {
  onFollowClick: smsModalActions.show
}


const SmartComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  TopicProfileLayout
)

module.exports = SmartComponent
